import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.css';
import './styles/custom.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';

ReactDOM.render(<Provider store={ store }><App /></Provider>, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
